import type { FaireProductEntity } from "../../entity_types/product";

export const p_hyf619k: FaireProductEntity = {
  token: "p_hyf619k",
  type: "product",
  name: "Craft Cold Brew Coffee",
  brandName: "Brooklyn Roasters",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5014e60de379b84682b4e7ab84b3ebc84f56a11f4ed37efb6b78e49753b0514b.webp",
  priceDollars: 6,
  description: "Premium cold brew coffee with NYC flair",
  categoryTokens: ["cat_food-beverages"],
  tags: ["nyc-local", "premium", "sparkling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/5014e60de379b84682b4e7ab84b3ebc84f56a11f4ed37efb6b78e49753b0514b.webp",
  weight: 1.5,
  dimensions: {
    width: 3,
    height: 9,
    depth: 3,
  },
  inStock: true,
};
